import { SectionExercise } from 'app/types/graphql';

type MetricValue = number | null;

type FormatDetailedMetric = {
  unit: string,
  metric?: { min?: MetricValue, max?: MetricValue, single?: MetricValue },
  deprecatedValue?: MetricValue,
  divider?: string,
};

export const lengthFromDurationSeconds = (duration: number, showSecs = false) => {
  if (duration === -1) {
    return 'FRT';
  }
  const wholeMinutes = Math.floor(duration / 60);
  const minutes = Math.ceil(duration / 60);
  const seconds = Math.ceil(duration % 60);

  if (showSecs) {
    return `${wholeMinutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  return `${minutes} ${minutes === 1 ? 'MIN' : 'MINS'}`;
}

export const minutesToSeconds = (durationInMinutes: number) => durationInMinutes * 60;

const formatDetailedMetric = ({
  unit,
  metric,
  deprecatedValue,
  divider = '/',
}: FormatDetailedMetric) => {
  if (!metric && !deprecatedValue) {
    return null;
  }

  if (typeof metric?.min === 'number' && typeof metric?.max === 'number') {
    if (metric.min === metric.max) {
      return `${metric.min}${unit}`;
    }
    return `${metric.min}${divider}${metric.max}${unit}`;
  }

  if (typeof metric?.single === 'number') {
    return metric.single === -1 ? `MAX ${unit}` : `${metric.single}${unit}`;
  }

  if (typeof deprecatedValue === 'number') {
    return deprecatedValue === -1 ? `MAX ${unit}` : `${deprecatedValue}${unit}`;
  }

  return null;
}

export const lengthFromExercise = ({ 
  duration, 
  distance, 
  repetitions, 
  detailedMetrics 
}: Partial<SectionExercise>) => {
  const durationLength = duration ? lengthFromDurationSeconds(duration, true) : null;

  const repetitionsLength = formatDetailedMetric({
    metric: detailedMetrics?.repetitions,
    deprecatedValue: repetitions,
    unit: 'x',
  });

  const distanceLength = formatDetailedMetric({
    metric: detailedMetrics?.distance,
    deprecatedValue: distance,
    unit: ' M',
  });

  const lengths = [durationLength, repetitionsLength, distanceLength].filter((len) => !!len);

  return lengths.join(' / ');
}
